module.exports = __webpack_public_path__ + "static/media/8.question.2db4339a.mp4";